import React from 'react';
import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-light-teal/40 py-14 px-4 relative" data-id="element-84">
      <div className="max-w-4xl mx-auto text-center" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-[2.5rem] shadow-2xl shadow-dark-teal/10 relative overflow-hidden" data-id="element-86">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-soft-teal via-coral to-soft-teal" data-id="element-87"></div>

          <div className="mx-auto w-16 h-16 bg-light-teal rounded-full flex items-center justify-center mb-5" data-id="element-88">
            <Brain className="text-dark-teal w-8 h-8" data-id="element-89" />
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-dark-teal mb-5" data-id="element-90">
            El Protocolo de Inmersión Acelerada de 3 Días
          </h2>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6" data-id="element-91">
            Este sistema colapsa meses de "intentos" en un solo fin de semana
            largo de 72 horas. Usamos la retroalimentación biológica inmediata:
            al eliminar la barrera del pañal, el sistema nervioso del niño
            recibe una señal clara e instantánea de su cuerpo.
          </p>

          <div className="inline-block bg-dark-teal text-white text-xl md:text-2xl font-bold py-4 px-8 rounded-2xl shadow-lg transform -rotate-1" data-id="element-92">
            No es magia, es neurología aplicada a la crianza.
          </div>
        </motion.div>
      </div>
    </section>;
}